import * as React from 'react';
import {Typography} from '@mui/material'
import AppView from "~common/components/app-view/index"
import * as request from "superagent";
// import { cpus } from 'os';



interface Props extends React.HTMLProps<HTMLDivElement>{
};

type State = {
  hasError: boolean
};

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props:Props) {
    super(props)
    this.state = { hasError: false };
  }

  componentDidCatch(error:Error, info:any) {
		this.setState({ hasError: true });
		this.logErrorToService(error, info);
  }


  logErrorToService = (error:Error, info:any) => {
    // TODO: jdouglas Implement logging for new service Fri Dec 15 11:49:31 2017
    // Perhaps use websockets to report the error to the server and allow for streaming viewing and also for server-side implementation
    request.post("/api/error-boundary/record").send(info).then((response: request.Response)=>{
	  // console.log("error-boundary response", response)
	  if(!response.ok){
			if (response.body) {
				console.warn("Failed to send debug info to server:", response.body)
			}
	  	} else {

	  	}
    }).catch((err: any)=>{
		console.warn("Failed to send debug info to server:", (err.response || { text: err.toString() }).text)
    })
  }

  reloadPage = () => {
	  window.location.reload()
  }

  render() {
    // console.log("Error boundary")
    if (this.state.hasError) {
      // ATTENTION: jdouglas You can update the content that is displayed here Fri Dec 15 11:53:37 2017
      return (
        <AppView history={history}>
            <Typography variant="subtitle1">Something went wrong. Click <a href="" onClick={this.reloadPage}>Here</a> to reload the page. If the problem persists, please contact a system administrator. </Typography> 
        </AppView>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
